import React, { useState } from "react";

const SignupPage = ({ onBackToLogin }) => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const params = new URLSearchParams(window.location.search);
  const inviteToken = params.get("invite");
  const isProSignup = params.get("plan") === "pro";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSignup = async () => {
    setLoading(true);
    setMessage("");
    setError("");

    try {
      const res = await fetch(`${API_BASE_URL}/auth/signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email,
          password,
          confirm_password: confirmPassword,
          invite_token: inviteToken
        })
      });

      const data = await res.json();

      if (!res.ok) {
        const errorMessage = Array.isArray(data.detail)
            ? data.detail.map((err) => err.msg).join(", ")
            : data.detail || "Signup failed";

        setError(errorMessage);
        setLoading(false);
        return;
      }

      setMessage(data.message);

    } catch {
      setError("Error calling API");
    }

    setLoading(false);
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#030712",
        fontFamily: "Arial",
        color: "white"
      }}
    >
      <div
        style={{
          width: "420px",
          padding: "36px",
          borderRadius: "18px",
          background: "rgba(15,23,42,0.95)",
          border: "1px solid rgba(255,255,255,0.08)"
        }}
      >
        <h1 style={{ textAlign: "center", marginBottom: "12px" }}>
          Create account
        </h1>

        <p
          style={{
            textAlign: "center",
            color: "#94a3b8",
            marginBottom: "28px"
          }}
        >
          {inviteToken
            ? "Create your account to accept the workspace invite."
            : isProSignup
              ? "Confirm your email and we'll take you straight to checkout for Pro."
              : "Start generating Jira tickets in minutes."}
        </p>

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={inputStyle}
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={inputStyle}
        />

        <input
          type="password"
          placeholder="Confirm password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSignup()}
          style={inputStyle}
        />

        <button
          onClick={handleSignup}
          style={{
            width: "100%",
            padding: "14px",
            borderRadius: "12px",
            border: "none",
            cursor: "pointer",
            background: "#4f46e5",
            color: "white",
            fontWeight: 700
          }}
        >
          {loading ? "Creating account..." : "Create account"}
        </button>

        <button
          onClick={onBackToLogin}
          style={{
            width: "100%",
            padding: "12px",
            marginTop: "12px",
            borderRadius: "12px",
            background: "transparent",
            border: "1px solid rgba(255,255,255,0.12)",
            color: "white",
            cursor: "pointer"
          }}
        >
          Back to login
        </button>

        {message && (
          <p
            style={{
              marginTop: "18px",
              color: "#86efac",
              textAlign: "center",
              lineHeight: 1.5
            }}
          >
            {message}
          </p>
        )}

        {error && (
          <p
            style={{
              marginTop: "18px",
              color: "#fca5a5",
              textAlign: "center"
            }}
          >
            {error}
          </p>
        )}
      </div>
    </div>
  );
};

const inputStyle = {
  width: "100%",
  padding: "14px",
  marginBottom: "14px",
  borderRadius: "10px",
  border: "1px solid rgba(255,255,255,0.12)",
  background: "rgba(255,255,255,0.06)",
  color: "white",
  boxSizing: "border-box"
};

export default SignupPage;
